<template lang="pug">
.gif-cards
  img.gift-cards__decoration(
    :src="'/svg/gift-cards/Background.svg'"
  )
  .gift-cards__elements
    Headline
    .gift-cards__elements-cards
      Card.gift-cards__elements-cards-el(v-for="card in gifts" :key="card.price_id" @click="onCardClicked" :info="card" renderBuyButton)
    HowItWorks
    Faqs(v-if="faqs && faqs.length > 0" :faqs="faqs")
</template>

<script>
import getMeta from '@/lib/meta'
import { config } from '@/config'

import Headline from '@/components/pages/gift-cards/headline/index'
import Card from '@/components/pages/gift-cards/card/index'
import HowItWorks from '@/components/pages/gift-cards/how-it-works/index'
import Faqs from '@/components/pages/gift-cards/faqs/index'
import eventSystem from '@/lib/event-system/index.js'

export default {
  components: {
    Headline,
    Card,
    HowItWorks,
    Faqs
  },

  layout: 'landing',

  middleware: ['languageRedirect'],

  async asyncData (ctx) {
    const gifts = await ctx.store.dispatch('gift-cards/fetchGifts')
    const faqs = await ctx.store.dispatch('gift-cards/fetchFaqs')

    return { gifts, faqs }
  },

  head () {
    const resultMeta = getMeta({
      title: this.$t('meta.ssr_gift_cards.main.title'),
      metaTitle: this.$t('meta.ssr_gift_cards.main.metaTitle'),
      description: this.$t('meta.ssr_gift_cards.main.description'),
      route: this.$route,
      i18nLocales: this.$i18n.locales,
      i18nSeo: this.$nuxtI18nSeo(),
      options: {
        gdpr: this.$store.state.auth.gdprThirdParty
      }
    })

    // json+ld data
    const jsonLdOrganisationInfo = {
      '@type': 'Organization',
      '@context': 'https://schema.org',
      foundingDate: '2018',
      name: 'RSS.com',
      alternateName: 'RSS․com',
      url: config.baseUrl,
      logo: config.baseUrl + '/icon@2x.png',
      sameAs: [
        'https://twitter.com/rss',
        'https://www.facebook.com/rss.podcasting',
        'https://www.linkedin.com/company/rsscom',
        'https://www.instagram.com/rss_podcasting'
      ]
    }

    resultMeta.script.push({
      type: 'application/ld+json',
      innerHTML: JSON.stringify(jsonLdOrganisationInfo)
    })

    return resultMeta
  },
  methods: {
    onCardClicked (price) {
      eventSystem.GA.send('purchase-gift-card-selection')

      const url = this.$locatedLink('/gift-cards/details/')

      const queryParams = this.$route.query
      queryParams.price = price

      this.$router.push({
        path: `${url}?${new URLSearchParams(queryParams).toString()}`
      })
    }
  }
}
</script>

<style lang="scss">
@import './../../components/pages/landing/index.scss';
</style>

<style lang="scss" scoped>
.gift-cards {
  position: relative;

  &__decoration {
    z-index: 0;
    position: absolute;
    width: 100%;
    bottom: -312px;
  }
  &__elements {
    position: relative;
    display: flex;
    flex-direction: column;
    gap: $gap * 2.5;
    z-index: 5;
    max-width: 726px;
    margin: 40px auto 28px auto;

    @include display-less(tablet) {
      margin: 40px $gap 28px $gap;
      grid-template-columns: 1fr;
    }

    @include display-less(desktop) {
      padding-bottom: $gap * 5;
    }

    &-cards {
      display: grid;
      grid-template-columns: repeat(2, 343px);
      grid-gap: $gap * 2.5;

      @include display-less(tablet) {
        grid-template-columns: 1fr;
      }

      &-el {
        max-width: 343px;
        @include display-less(tablet) {
          margin-left: auto;
          margin-right: auto;
        }
      }
    }
  }
}
</style>
